import angular from 'angular';

angular
  .module('cloudX')
  .controller('AvailableRelationTagsDialogCtrl', [
    '$scope',
    'close',
    'resourceFactorySvc',
    '$filter',
    '$http',
    'appUrls',
    'flySvc',
    'dialogsSvc',
    AvailableRelationTagsDialogCtrl,
  ]);

function AvailableRelationTagsDialogCtrl(
  $scope,
  close,
  resourceFactorySvc,
  $filter,
  $http,
  appUrls,
  flySvc,
  dialogsSvc,
) {
  $scope.tags = [];
  $scope.noTags = false;
  var removedTags = [];
  var updatedTags = [];

  var init = () => {
    return $http.get(`${appUrls.api}/api/relationtag/getall`).then(
      ({ data }) => {
        if (!data || !data.length) {
          $scope.noTags = true;
        } else {
          $scope.tags = data.map(x => ({
            ...x,
            selected: false,
          }));
          $scope.tags = $filter('orderBy')($scope.tags, 'name');
        }
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
        return '';
      },
    );
  };
  init();

  $scope.cancel = function() {
    close({ selectedTags: null, updatedTags, removedTags }, 500);
  };

  $scope.select = function(result) {
    var selectedTags = $scope.tags && $scope.tags.filter(x => x.selected).map(x => x.name);
    close({ selectedTags, updatedTags, removedTags }, 500);
  };

  $scope.update = (tag, value, field) => {
    if (angular.equals(tag[field], value)) return false;
    if (!value) return false;
    var model = angular.copy(tag);
    model[field] = value;

    return $http.put(`${appUrls.api}/api/relationtag`, model).then(
      ({ data }) => {
        if (data) {
          angular.extend(tag, data);
          flySvc.success();
          updatedTags = [tag, ...updatedTags];
        }
        return false;
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
        return '';
      },
    );
  };

  $scope.showDeleteDialog = tag => {
    dialogsSvc.showYesNo('msgConfirmDeleteTitle', 'msgConfirmDeleteRelationTag').then(function() {
      $http.delete(`${appUrls.api}/api/relationtag/${tag.id}`).then(
        () => {
          var idx = $scope.tags.indexOf(tag);
          if (idx >= 0) $scope.tags.splice(idx, 1);
          removedTags = [tag.id, ...removedTags];
        },
        function(error) {
          flySvc.error(error.data.code, error.data.parameters);
          return '';
        },
      );
    });
  };
}
